import {
  growthFormatter, integerFormatter,
  intGrowthFormatter, numberFormatter,
  percentageBarFormatter,
  percentageGrowthFormatter
} from "../../gridFormatters";
import { wtPctAvg } from "../../math";

export const clusterDeltaReportDefs = [
  {
    "field": "datacenter_name",
    "headerName": "Data Center"
  },
  {
    "field": "beginning_num_vms",
    "headerName": "Beginning # VMs",
    "type": "numericColumn",
    "cellRenderer": integerFormatter,
    "hide": true
  },
  {
    "field": "ending_num_vms",
    "headerName": "Ending # VMs",
    "type": "numericColumn",
    "cellRenderer": integerFormatter,
    "hide": true
  },
  {
    "field": "vms_growth",
    "headerName": "# VMs Growth",
    "type": "numericColumn",
    "cellRenderer": intGrowthFormatter
  },
  {
    "field": "beginning_vcpus",
    "headerName": "Beginning vCPUs",
    "type": "numericColumn",
    "cellRenderer": integerFormatter,
    "hide": true
  },
  {
    "field": "ending_vcpus",
    "headerName": "Ending vCPUs",
    "type": "numericColumn",
    "cellRenderer": integerFormatter,
    "hide": true
  },
  {
    "field": "vcpus_growth",
    "headerName": "vCPUs Growth",
    "type": "numericColumn",
    "cellRenderer": intGrowthFormatter
  },
  {
    "field": "beginning_total_memory",
    "headerName": "Beginning Total Memory (GiB)",
    "type": "numericColumn",
    "cellRenderer": numberFormatter,
    "hide": true
  },
  {
    "field": "ending_used_memory",
    "headerName": "Ending Used Memory (GiB)",
    "type": "numericColumn",
    "cellRenderer": numberFormatter,
  },
  {
    "field": "ending_total_memory",
    "headerName": "Ending Total Memory (GiB)",
    "type": "numericColumn",
    "cellRenderer": numberFormatter,
    "hide": true
  },
  {
    "field": "memory_growth",
    "headerName": "Memory Growth (GiB)",
    "type": "numericColumn",
    "cellRenderer": growthFormatter
  },
  {
    "field": "beginning_disk_capacity",
    "headerName": "Beginning Disk Capacity (GiB)",
    "type": "numericColumn",
    "cellRenderer": numberFormatter,
    "hide": true
  },
  {
    "field": "ending_disk_capacity",
    "headerName": "Ending Disk Capacity (GiB)",
    "type": "numericColumn",
    "cellRenderer": numberFormatter,
    "hide": true
  },
  {
    "field": "disk_alloc_growth",
    "headerName": "Disk Allocated Growth (GiB)",
    "type": "numericColumn",
    "cellRenderer": growthFormatter
  },
  {
    "field": "beginning_cpu_util_pct",
    "headerName": "Beginning % CPU",
    "type": "numericColumn",
    "cellRenderer": percentageBarFormatter,
    "aggFunc": (params) => {
      return wtPctAvg(params, "beginning_vcpus", "beginning_vcpus_capacity");
    },
    "hide": true
  },
  {
    "field": "ending_cpu_util_pct",
    "headerName": "Ending % CPU",
    "type": "numericColumn",
    "cellRenderer": percentageBarFormatter,
    "aggFunc": (params) => {
      return wtPctAvg(params, "ending_vcpus", "ending_vcpus_capacity");
    },
    "hide": true
  },
  {
    "field": "cpu_util_growth_pct",
    "headerName": "CPU % Growth",
    "type": "numericColumn",
    "cellRenderer": percentageGrowthFormatter,
    "aggFunc": (params) => {
      return wtPctAvg(params, "beginning_vcpus", "ending_vcpus");
    },
  },
  {
    "field": "beginning_memory_util_pct",
    "headerName": "Beginning % Memory",
    "type": "numericColumn",
    "cellRenderer": percentageBarFormatter,
    "aggFunc": (params) => {
      return wtPctAvg(params, "beginning_used_memory", "beginning_total_memory");
    },
    "hide": true
  },
  {
    "field": "ending_memory_util_pct",
    "headerName": "Ending % Memory",
    "type": "numericColumn",
    "cellRenderer": percentageBarFormatter,
    "aggFunc": (params) => {
      return wtPctAvg(params, "ending_used_memory", "ending_total_memory");
    },
    "hide": true
  },
  {
    "field": "memory_util_growth_pct",
    "headerName": "Memory % Growth",
    "type": "numericColumn",
    "cellRenderer": percentageGrowthFormatter,
    "aggFunc": (params) => {
      const beg = wtPctAvg(params, "beginning_used_memory", "beginning_total_memory");
      const end = wtPctAvg(params, "ending_used_memory", "ending_total_memory");
      return beg - end;
    },
  },
  {
    "field": "beginning_disk_util_pct",
    "headerName": "Beginning % Disk",
    "type": "numericColumn",
    "cellRenderer": percentageBarFormatter,
    "hide": true,
    "aggFunc": (params) => {
      return wtPctAvg(params, "beginning_disk_used", "beginning_disk_capacity");
    },
  },
  {
    "field": "ending_disk_util_pct",
    "headerName": "Ending % Disk",
    "type": "numericColumn",
    "cellRenderer": percentageBarFormatter,
    "hide": true,
    "aggFunc": (params) => {
      return wtPctAvg(params, "ending_disk_used", "ending_disk_capacity");
    },
  },
  {
    "field": "disk_util_growth_pct",
    "headerName": "Disk % Growth",
    "type": "numericColumn",
    "cellRenderer": percentageGrowthFormatter,
    "aggFunc": (params) => {
      return wtPctAvg(params, "beginning_disk_capacity", "ending_disk_capacity");
    },
  },
  {
    "field": "beginning_vm_build_capacity",
    "headerName": "Beginning VM Build Capacity",
    "type": "numericColumn",
    "cellRenderer": integerFormatter,
    "hide": true
  },
  {
    "field": "ending_vm_build_capacity",
    "headerName": "End VM Build Capacity",
    "type": "numericColumn",
    "cellRenderer": integerFormatter,
    "hide": true
  },
  {
    "field": "vm_build_capacity_growth",
    "headerName": "VM Build Capacity Growth",
    "type": "numericColumn",
    "cellRenderer": intGrowthFormatter
  },
    {
    "field": "beginning_num_hosts",
    "headerName": "Beginning # Hosts",
    "type": "numericColumn",
    "cellRenderer": integerFormatter,
    "hide": true
  },
  {
    "field": "ending_num_hosts",
    "headerName": "Ending # Hosts",
    "type": "numericColumn",
    "cellRenderer": integerFormatter,
    "hide": true
  },
    {
    "field": "num_hosts_growth",
    "headerName": "# Hosts Growth",
    "type": "numericColumn",
    "cellRenderer": intGrowthFormatter,
    "aggFunc": "sum"
  },
];

export const vmsDeltaReportDefs = [
  {
    "field": "vm_name",
    "headerName": "VM"
  },
  {
    "field": "cluster_name",
    "headerName": "Cluster"
  },
    {
    "field": "datacenter_name",
    "headerName": "Data Center"
  },
  {
    "field": "beginning_vcpus",
    "headerName": "Beginning vCPUs",
    "type": "numericColumn",
    "cellRenderer": integerFormatter,
    "hide": true
  },
  {
    "field": "ending_vcpus",
    "headerName": "Ending vCPUs",
    "type": "numericColumn",
    "cellRenderer": integerFormatter,
    "hide": true
  },
  {
    "field": "vcpus_growth",
    "headerName": "vCPUs Growth",
    "type": "numericColumn",
    "cellRenderer": intGrowthFormatter
  },
  {
    "field": "beginning_total_memory",
    "headerName": "Beginning Total Memory (GiB)",
    "type": "numericColumn",
    "cellRenderer": numberFormatter,
    "hide": true
  },
  {
    "field": "beginning_used_memory",
    "headerName": "Beginning Used Memory (GiB)",
    "type": "numericColumn",
    "cellRenderer": numberFormatter,
  },
  {
    "field": "ending_used_memory",
    "headerName": "Ending Used Memory (GiB)",
    "type": "numericColumn",
    "cellRenderer": numberFormatter,
  },
  {
    "field": "ending_total_memory",
    "headerName": "Ending Total Memory (GiB)",
    "type": "numericColumn",
    "cellRenderer": numberFormatter,
    "hide": true
  },
  {
    "field": "memory_growth",
    "headerName": "Memory Growth (GiB)",
    "type": "numericColumn",
    "cellRenderer": growthFormatter,
  },
  {
    "field": "beginning_disk_capacity",
    "headerName": "Beginning Disk Capacity (GiB)",
    "type": "numericColumn",
    "cellRenderer": numberFormatter,
    "hide": true
  },
  {
    "field": "ending_disk_capacity",
    "headerName": "Ending Disk Capacity (GiB)",
    "type": "numericColumn",
    "cellRenderer": numberFormatter,
    "hide": true
  },
  {
    "field": "disk_alloc_growth",
    "headerName": "Disk Allocated Growth (GiB)",
    "type": "numericColumn",
    "cellRenderer": growthFormatter
  },
  {
    "field": "beginning_cpu_util_pct",
    "headerName": "Beginning % CPU",
    "type": "numericColumn",
    "cellRenderer": percentageBarFormatter,
    "hide": true,
    "aggFunc": (params) => {
      return wtPctAvg(params, "beginning_vcpus", "beginning_vcpus_capacity");
    }
  },
  {
    "field": "ending_cpu_util_pct",
    "headerName": "Ending % CPU",
    "type": "numericColumn",
    "cellRenderer": percentageBarFormatter,
    "hide": true,
    "aggFunc": (params) => {
      return wtPctAvg(params, "ending_vcpus", "ending_vcpus_capacity");
    }
  },
  {
    "field": "cpu_util_growth_pct",
    "headerName": "CPU % Growth",
    "type": "numericColumn",
    "cellRenderer": percentageGrowthFormatter,
    "aggFunc": (params) => {
      return wtPctAvg(params, "beginning_vcpus", "ending_vcpus");
    }
  },
  {
    "field": "beginning_memory_util_pct",
    "headerName": "Beginning % Memory",
    "type": "numericColumn",
    "cellRenderer": percentageBarFormatter,
    "hide": true,
    "aggFunc": (params) => {
      return wtPctAvg(params, "beginning_used_memory", "beginning_total_memory");
    }
  },
  {
    "field": "ending_memory_util_pct",
    "headerName": "Ending % Memory",
    "type": "numericColumn",
    "cellRenderer": percentageBarFormatter,
    "hide": true,
    "aggFunc": (params) => {
      return wtPctAvg(params, "ending_used_memory", "ending_total_memory");
    }
  },
  {
    "field": "memory_util_growth_pct",
    "headerName": "Memory % Growth",
    "type": "numericColumn",
    "cellRenderer": percentageGrowthFormatter,
    "aggFunc": (params) => {
      return wtPctAvg(params, "beginning_used_memory", "ending_total_memory");
    }
  },
  {
    "field": "beginning_disk_util_pct",
    "headerName": "Beginning % Disk",
    "type": "numericColumn",
    "cellRenderer": percentageBarFormatter,
    "aggFunc": (params) => {
      return wtPctAvg(params, "beginning_disk_used", "beginning_disk_capacity");
    },
    "hide": true
  },
  {
    "field": "ending_disk_util_pct",
    "headerName": "Ending % Disk",
    "type": "numericColumn",
    "cellRenderer": percentageBarFormatter,
    "aggFunc": (params) => {
      return wtPctAvg(params, "ending_disk_used", "ending_disk_capacity");
    },
    "hide": true
  },
  {
    "field": "disk_util_growth_pct",
    "headerName": "Disk % Growth",
    "type": "numericColumn",
    "cellRenderer": percentageGrowthFormatter,
    "aggFunc": (params) => {
      return wtPctAvg(params, "beginning_disk_capacity", "ending_disk_capacity");
    },
  },
];